import { render } from "./miniSpinner.vue?vue&type=template&id=1143f396&scoped=true&ts=true"
import script from "./miniSpinner.vue?vue&type=script&lang=ts"
export * from "./miniSpinner.vue?vue&type=script&lang=ts"

import "./miniSpinner.vue?vue&type=style&index=0&id=1143f396&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1143f396"]])

export default __exports__